import { render, staticRenderFns } from "./DictTag.vue?vue&type=template&id=15a05e7a&"
import script from "./DictTag.vue?vue&type=script&lang=js&"
export * from "./DictTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports